import Image from "next/image";

export default function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary">
      <div className="h-12 w-12 flex items-center justify-center">
        <Image
          src="/batchfinderLogo.png"
          alt="BatchFinder Logo"
          width={48}
          height={48}
          className="animate-spin"
          priority
        />
      </div>
    </div>
  );
} 